import styled from "styled-components";

interface Props {
  versions: number[]
}
interface CircleProps {
  color: string
}
export const ChartsRow = styled.div<Props>`
  display: grid;
  // pass version props for amount of columns
  grid-template-columns: ${props => props.versions && `repeat(${props.versions.length}, minmax( 200px, 1fr))`};
  justify-items: center;
  border-bottom: 1px solid grey;
`
export const CardBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items : center;
  & .score {
    font-size: 2rem;
    color: #000000;
  }
`
export const GridRow = styled.div`
  display: flex;
  align-items: center;

`
export const RowName = styled.span`
color: #000000;
  width: 250px;
  height: 157px;
  margin: 0;
  font-size: 1.5rem;
`
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const GridContainer = styled.div<Props>`
  display: grid;
  grid-template-columns: ${props => props.versions && `repeat(${props.versions.length}, minmax( 160px, 1fr))`};
  max-width: calc(100% - 400px);
`

export const EmptyCircle = styled.div<CircleProps>`
  width: 60px;
  height: 60px;
  border-width: 5px;
  border-style: dotted;
  border-color: ${props => props.color };
  border-radius: 50% 50%;
  margin: 30px 50px;
  opacity: 50%;
`
/////////////////////////////
// MINIMIZED VIEW
/////////////////////////////
export const MiniChartsRow = styled.div<Props>`
  display: grid;
  // pass version props for amount of columns
  grid-template-columns: ${props => props.versions && `repeat(${props.versions.length}, minmax(60px, 1fr))`};
  justify-items: center;
  //border-bottom: 1px solid grey;
`
export const MiniCardBlock = styled.div`
  display: flex;
  align-items : center;
  & .score {
    font-size:1.5rem;
    color: #000000;
  }
`
export const MiniRowName = styled.span`
  color: #000000;
  font-size: 1.5rem;
`



// WEBPACK FOOTER //
// ./src/sbtool/component/ProjectVersionParamsForm/EvaluationGrid/Evaluation.styled.ts